import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { ChanelConfig } from '../../../../../configs/GlobalConfig';
import MessageHub from '../../../../../core/signalr/SignalrMessageHub';
import TabFilter from '../../../../common/tab-filter';
import { getDefaultIfEmpty } from '../../../../helpers/Common';
import {
  cancelfetchDataAbnormality,
  fetchDataAbnormality,
  subscribeRealtimeTickAbnormality,
  changeFilterLineOne,
  changeFilterLineTwo,
  changeFilterLineThree,
  REDUCER_NAME,
  loadMoreAbnormality,
} from '../reducer';
import { SimpleTooltip } from '../../../../common/tooltip';
import Const from './Const';
import Table from './Table';
import { formatTextFloat } from '../../../../helpers/Text';

const defaultSortState = { totalMatchVolume: 'desc' };

class Abnormality extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sortState: defaultSortState,
    };
    this.tableRef = React.createRef();
  }

  componentDidMount() {
    this.fetchData();
    MessageHub.subscribe(ChanelConfig.TickChanel, this.dispatchDataRealtime);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { currentSearch, watchListId } = this.props;
    if (
      currentSearch !== nextProps.currentSearch ||
      watchListId !== nextProps.watchListId
    ) {
      this.setState({
        page: 1,
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { sortState } = this.state;
    const { currentSearch, watchListId, filter } = this.props;
    if (
      currentSearch !== prevProps.currentSearch ||
      watchListId !== prevProps.watchListId ||
      sortState !== prevState.sortState ||
      filter !== prevProps.filter
    ) {
      this.fetchData();
      if (this.tableRef.current) {
        this.tableRef.current.scrollToTop();
      }
    }
  }

  componentWillUnmount() {
    const { cancelfetchDataAbnormality } = this.props;
    cancelfetchDataAbnormality();
    MessageHub.unsubscribe(ChanelConfig.TickChanel, this.dispatchDataRealtime);
  }

  fetchData = () => {
    const { sortState } = this.state;
    const { fetchDataAbnormality, filter } = this.props;
    fetchDataAbnormality(
      Const.filterAbnormalityType[filter.filterLineOne].text,
      Const.filterAvgVolume[filter.filterLineTwo],
      Const.filterRate[filter.filterLineThree],
      sortState,
    );
  };

  onLoadMore = page => {
    const { sortState } = this.state;
    const { loadMoreAbnormality, filter } = this.props;
    this.setState({ page });
    loadMoreAbnormality({
      page,
      sortState,
      currentType: Const.filterAbnormalityType[filter.filterLineOne].text,
      currentAvgVolume: Const.filterAvgVolume[filter.filterLineTwo],
      currentRate: Const.filterRate[filter.filterLineThree],
    });
  };

  dispatchDataRealtime = data => {
    const { subscribeRealtimeTickAbnormality } = this.props;
    subscribeRealtimeTickAbnormality(data);
  };

  changeType = currentType => {
    const { changeFilterLineOne } = this.props;
    changeFilterLineOne(currentType);
  };

  changeAvgVolume = currentAvgVolume => {
    const { changeFilterLineTwo } = this.props;
    changeFilterLineTwo(currentAvgVolume);
  };

  changeRate = currentRate => {
    const { changeFilterLineThree } = this.props;
    changeFilterLineThree(currentRate);
  };

  onSort = sortState => {
    this.setState({
      sortState: getDefaultIfEmpty(sortState, defaultSortState),
    });
  };

  render() {
    const { page } = this.state;
    const { filter } = this.props;
    return (
      <div className="d-flex flex-column flex-fill">
        <div>
          <div className="list-filter top-nav">
            <span className="left-label">
              {I18n.t('tasignals.abnormalityContent.line_2')}
            </span>
            <TabFilter
              currentTab={filter.filterLineOne}
              listTab="tasignals.filterAbnormalityType"
              changeTab={this.changeType}
            />
          </div>
          <div className="list-filter top-nav">
            <span className="left-label">
              {I18n.t('tasignals.abnormalityContent.line_3')}
            </span>
            <TabFilter
              currentTab={filter.filterLineTwo}
              listTab="tasignals.filterAvgVolume"
              changeTab={this.changeAvgVolume}
            />
          </div>
          <div className="list-filter top-nav">
            <span className="left-label">
              {I18n.t('tasignals.abnormalityContent.line_4.part_1')}
              <small>
                {I18n.t('tasignals.abnormalityContent.line_4.part_2')}
              </small>
            </span>
            <TabFilter
              currentTab={filter.filterLineThree}
              listTab="tasignals.filterRate"
              changeTab={this.changeRate}
            />
          </div>
          <div className="list-text-display">
            <span className="light-text">
              {I18n.t('tasignals.abnormalityContent.line_5.part_1')}
            </span>
            <span className="bold-text">
              {I18n.t(Const.filterAbnormalityType[filter.filterLineOne].quote)}
            </span>
            <span className="light-text">
              {I18n.t('tasignals.abnormalityContent.line_5.part_2')}
            </span>
            <span className="bold-text">
              {I18n.t('tasignals.abnormalityContent.line_5.part_3')}
            </span>
            <span className="bold-text">
              {formatTextFloat(
                Number(Const.filterAvgVolume[filter.filterLineTwo]),
                0,
              )}
            </span>
            <span className="light-text">
              {I18n.t('tasignals.abnormalityContent.line_5.part_4')}
            </span>
            <span className="bold-text">
              {I18n.t('tasignals.abnormalityContent.line_5.part_5')}
              {Const.filterRate[filter.filterLineThree]}
            </span>
          </div>
        </div>
        <div className="mt-10 d-flex flex-fill">
          <Table
            page={page}
            scrollRef={this.tableRef}
            onLoadMore={this.onLoadMore}
            onSort={this.onSort}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    currentSearch: state[REDUCER_NAME].currentSearch,
    watchListId: state[REDUCER_NAME].watchListId,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchDataAbnormality: (
      currentType,
      currentAvgVolume,
      currentRate,
      sortState,
    ) =>
      dispatch(
        fetchDataAbnormality(
          currentType,
          currentAvgVolume,
          currentRate,
          sortState,
        ),
      ),
    cancelfetchDataAbnormality: () => dispatch(cancelfetchDataAbnormality()),
    subscribeRealtimeTickAbnormality: data =>
      dispatch(subscribeRealtimeTickAbnormality(data)),
    changeFilterLineOne: value => dispatch(changeFilterLineOne(value)),
    changeFilterLineTwo: value => dispatch(changeFilterLineTwo(value)),
    changeFilterLineThree: value => dispatch(changeFilterLineThree(value)),
    loadMoreAbnormality: value => dispatch(loadMoreAbnormality(value)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Abnormality);
